import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { CONFIG } from '../../config';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, CONFIG.i18nPath, '.json' + '?cb=' + (new Date()).getTime());
}
